__webpack_require__.p = "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278";